module.exports = __webpack_public_path__ + "img/play_test.b1cc9b9f.png";